import React from 'react';
import { Box, Typography, Stack, IconButton, Divider } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';

const ReferenceList = ({ references, onEdit, onDelete }) => {
    if (!references || references.length === 0) {
        return (
            <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
                No references added yet
            </Typography>
        );
    }

    return (
        <Box>
            {references.map((ref, idx) => (
                <Box key={ref.id}>
                    <Box
                        sx={{
                            py: 1.25,
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'space-between',
                            gap: 1,
                        }}
                    >
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                            {/* Line 1: name · position */}
                            <Stack direction="row" spacing={0.75} alignItems="baseline" flexWrap="wrap">
                                <Typography variant="body2" fontWeight={600}>
                                    {ref.name}
                                </Typography>
                                {ref.position && (
                                    <>
                                        <Typography variant="body2" color="text.disabled">·</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {ref.position}
                                        </Typography>
                                    </>
                                )}
                            </Stack>

                            {/* Line 2: email / phone / location inline */}
                            {(ref.email || ref.phone_number || ref.location) && (
                                <Stack direction="row" spacing={1.5} flexWrap="wrap" sx={{ mt: 0.25 }}>
                                    {ref.email && (
                                        <Stack direction="row" spacing={0.5} alignItems="center">
                                            <EmailOutlinedIcon sx={{ fontSize: 12, color: 'text.disabled' }} />
                                            <Typography variant="caption" color="text.secondary">{ref.email}</Typography>
                                        </Stack>
                                    )}
                                    {ref.phone_number && (
                                        <Stack direction="row" spacing={0.5} alignItems="center">
                                            <PhoneOutlinedIcon sx={{ fontSize: 12, color: 'text.disabled' }} />
                                            <Typography variant="caption" color="text.secondary">{ref.phone_number}</Typography>
                                        </Stack>
                                    )}
                                    {ref.location && (
                                        <Stack direction="row" spacing={0.5} alignItems="center">
                                            <LocationOnOutlinedIcon sx={{ fontSize: 12, color: 'text.disabled' }} />
                                            <Typography variant="caption" color="text.secondary">{ref.location}</Typography>
                                        </Stack>
                                    )}
                                </Stack>
                            )}
                        </Box>

                        {(onEdit || onDelete) && (
                            <Stack direction="row" spacing={0.25} sx={{ flexShrink: 0, mt: -0.5 }}>
                                {onEdit && (
                                    <IconButton size="small" onClick={() => onEdit(ref)}>
                                        <EditIcon sx={{ fontSize: 15 }} />
                                    </IconButton>
                                )}
                                {onDelete && (
                                    <IconButton size="small" color="error" onClick={() => onDelete(ref)}>
                                        <DeleteIcon sx={{ fontSize: 15 }} />
                                    </IconButton>
                                )}
                            </Stack>
                        )}
                    </Box>
                    {idx < references.length - 1 && <Divider />}
                </Box>
            ))}
        </Box>
    );
};

export default ReferenceList;
